import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, Loader2, XCircle } from 'lucide-react';
import './MentorshipPage.css';

const API = process.env.REACT_APP_BACKEND_URL;

const MentorshipSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing'); // processing, success, error
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  
  const sessionId = searchParams.get('session_id');
  const planId = searchParams.get('plan');
  
  useEffect(() => {
    const processPayment = async () => {
      if (!sessionId) {
        setStatus('error');
        setError('No session ID provided');
        return;
      }
      
      try {
        const token = localStorage.getItem('hyperdriveToken');
        const response = await fetch(`${API}/api/mentorship/webhook/success?session_id=${sessionId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` })
          }
        });
        
        const data = await response.json();
        
        if (data.success) {
          setResult(data);
          setStatus('success');
        } else {
          setError(data.message || 'Failed to process payment');
          setStatus('error');
        }
      } catch (err) {
        console.error('Error processing payment:', err);
        setError('Failed to process payment. Please contact support.');
        setStatus('error');
      }
    };
    
    processPayment();
  }, [sessionId]);
  
  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };
  
  return (
    <div className="mentorship-page">
      <div className="mentorship-container">
        <div className="success-card">
          {status === 'processing' && (
            <>
              <Loader2 className="status-icon spinning" size={64} />
              <h1>Processing Your Purchase...</h1>
              <p>Please wait while we activate your mentorship package.</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <CheckCircle className="status-icon success" size={64} />
              <h1>Welcome to Mentorship!</h1>
              <p>{result?.message}</p>
              
              {result?.granted && result.granted.length > 0 && (
                <div className="granted-list">
                  <h3>What's Been Activated:</h3>
                  <ul>
                    {result.granted.map((item, index) => (
                      <li key={index}>
                        <CheckCircle size={16} />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              
              <div className="next-steps">
                <h3>What's Next?</h3>
                <p>Coach CJ will reach out within 24 hours to schedule your first session.</p>
              </div>
              
              <button className="dashboard-btn" onClick={handleGoToDashboard}>
                Go to Dashboard
              </button>
            </>
          )}
          
          {status === 'error' && (
            <>
              <XCircle className="status-icon error" size={64} />
              <h1>Something Went Wrong</h1>
              <p>{error}</p>
              <p className="support-note">
                If your payment was processed, please contact support with your session ID: 
                <code>{sessionId}</code>
              </p>
              <button className="dashboard-btn" onClick={handleGoToDashboard}>
                Go to Dashboard
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MentorshipSuccessPage;
